import { ModalHeader, Text } from '@livechat/design-system-react-components'

const RequestBuyModalHeader = () => (
  <ModalHeader title="Permission needed">
    <Text size="sm" data-test="ocp-modal-subheader">
      Only users with access to billing can complete this purchase.
    </Text>
  </ModalHeader>
)

export default RequestBuyModalHeader
